// extracted by mini-css-extract-plugin
export default {"container":"Sk-z","heading":"Tk-z","items":"Uk-z","action":"Vk-z","disabled":"Wk-z"};